function formatNumber(number, options = {}) {
  const numberFormatter = new Intl.NumberFormat("en-US", options);
  return numberFormatter.format(number);
}

export default formatNumber;
